export enum DeviceTypeEnum {
  MOBILE = "mobile",
  TABLET = "tablet",
  DESKTOP = "desktop",
}

export type DeviceType = {
  deviceType: "mobile" | "tablet" | "desktop";
  isMobile: boolean;
};
